import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { SubscriptionType } from '@sierralabs/state-machine';
import FormSection from './components/FormSection';
import { useFormContext } from './FormContext';
const StyledDiv = styled.div ``;
export const Form = ({ statePath, values, appendSectionControls, disableInlineSave, onInit, onChange, onStatePathChange, onStateNodeChange }) => {
    const formContext = useFormContext();
    const { stateMachine, formValues, setFormValues } = formContext;
    const previousFormValues = useRef(formValues);
    const previousStatePath = useRef(statePath);
    const mountRef = useRef(false);
    const onInitRef = useRef(onInit);
    const onChangeRef = useRef(onChange);
    const onStateNodeChangeRef = useRef(onStateNodeChange);
    const onStatePathChangeRef = useRef(onStatePathChange);
    const stateHistoryRef = useRef([]);
    const [stateNodes, setStateNodes] = useState([]);
    // register for transition changes
    useEffect(() => {
        if (!stateMachine)
            return;
        let startState;
        let selectedStateNodes = [];
        const onStart = (state, stateNode) => {
            // console.log('TRANSITION: onStart', state);
            selectedStateNodes = [];
            // skip root stateNode when state machine starts
            if (stateMachine.stateNode !== stateNode) {
                startState = state;
            }
            else {
                startState = undefined;
            }
        };
        const onChange = (state, stateNode) => {
            // console.log('TRANSITION: onChange', state);
            const lastStateNode = selectedStateNodes[selectedStateNodes.length - 1];
            if ((lastStateNode === null || lastStateNode === void 0 ? void 0 : lastStateNode.path) !== stateNode.path) {
                selectedStateNodes.push(stateNode);
            }
        };
        const onEnd = state => {
            var _a, _b;
            // console.log('TRANSITION: onEnd', state);
            // only update selected state nodes if transitioning away
            if (state.path !== (startState === null || startState === void 0 ? void 0 : startState.path)) {
                if (startState) {
                    stateHistoryRef.current.push(startState);
                }
                setStateNodes(selectedStateNodes);
                (_a = onStateNodeChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onStateNodeChangeRef, selectedStateNodes);
                (_b = onStatePathChangeRef.current) === null || _b === void 0 ? void 0 : _b.call(onStatePathChangeRef, state.path);
            }
        };
        stateMachine.subscribe(SubscriptionType.TransitionStart, onStart);
        stateMachine.subscribe(SubscriptionType.TransitionChange, onChange);
        stateMachine.subscribe(SubscriptionType.TransitionEnd, onEnd);
        return () => {
            stateMachine.unsubscribe(SubscriptionType.TransitionStart, onStart);
            stateMachine.unsubscribe(SubscriptionType.TransitionChange, onChange);
            stateMachine.unsubscribe(SubscriptionType.TransitionEnd, onEnd);
        };
    }, [stateMachine]);
    // initial values load
    useEffect(() => {
        if (values) {
            setFormValues(values);
        }
    }, [values, setFormValues]);
    // start the state machine on mount
    useEffect(() => {
        var _a;
        if (!stateMachine)
            return;
        const stateNode = statePath
            ? stateMachine.getStateNode(statePath)
            : undefined;
        if (!mountRef.current) {
            mountRef.current = true;
            formContext.formValues = values || formValues;
            if (statePath && stateNode) {
                setStateNodes([stateNode]);
                stateMachine.resume({ path: statePath, context: formContext });
            }
            else {
                stateMachine.start(formContext);
            }
            (_a = onInitRef.current) === null || _a === void 0 ? void 0 : _a.call(onInitRef, formContext);
        }
        else if (statePath &&
            stateNode &&
            previousStatePath.current !== statePath) {
            setStateNodes([stateNode]);
            stateMachine.resume({ path: statePath, context: formContext });
        }
        previousStatePath.current = statePath;
    }, [stateMachine, formContext, values, statePath, formValues]);
    useEffect(() => {
        var _a;
        if (formValues && formValues !== previousFormValues.current) {
            previousFormValues.current = formValues;
            (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef, formValues);
        }
    }, [formValues]);
    return (React.createElement(StyledDiv, null, stateNodes.map((stateNode, index) => (React.createElement(FormSection, { disableInlineSave: disableInlineSave, key: stateNode.name, stateNode: stateNode, appendSectionControls: index === stateNodes.length - 1 ? appendSectionControls : undefined, hasBack: stateHistoryRef.current.length > 0, onBack: () => {
            var _a, _b;
            const lastState = stateHistoryRef.current.pop();
            if (lastState) {
                const stateNode = stateMachine === null || stateMachine === void 0 ? void 0 : stateMachine.getStateNode(lastState.path);
                if (stateNode) {
                    setStateNodes([stateNode]);
                    stateMachine === null || stateMachine === void 0 ? void 0 : stateMachine.resume(lastState);
                    (_a = onStateNodeChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onStateNodeChangeRef, [stateNode]);
                    (_b = onStatePathChangeRef.current) === null || _b === void 0 ? void 0 : _b.call(onStatePathChangeRef, lastState.path);
                }
            }
        }, onTransition: event => {
            stateMachine === null || stateMachine === void 0 ? void 0 : stateMachine.transition(event.name);
        } })))));
};
export default Form;
//# sourceMappingURL=Form.js.map